export const enum WIZARD_ORIENTATION {
  HORIZONTAL = "HORIZONTAL",
  VERTICAL = "VERTICAL",
}
